import { render, staticRenderFns } from "./StocksView.vue?vue&type=template&id=706ef513&scoped=true"
import script from "./StocksView.vue?vue&type=script&lang=js"
export * from "./StocksView.vue?vue&type=script&lang=js"
import style0 from "./StocksView.vue?vue&type=style&index=0&id=706ef513&prod&lang=scss"
import style1 from "./StocksView.vue?vue&type=style&index=1&id=706ef513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ef513",
  null
  
)

export default component.exports